import useSWR from 'swr';

import apiRequest from '@/services/apiRequest';
import { getSearchApi } from '@/utility/getCoreApi';

interface INearbyParkImage {
  season: string;
  url: string;
}

interface INearbyParkAddress {
  canada_province: string;
  country_area: string;
  state_code: string;
  state_name: string;
}

interface INearbyParkAggs {
  avg_price: number;
  max_price: number;
  med_price: number;
  min_price: number;
}

export interface INearbyPark {
  slug: string;
  id: string;
  metadata: {
    address: INearbyParkAddress;
    images?: INearbyParkImage[];
    seo_title?: string;
    title?: string;
    aggs?: INearbyParkAggs;
  };
}

type TParkType = 'national' | 'state';

export const useNearbyParks = (
  lat?: number,
  lon?: number,
  type: TParkType = 'national',
  limit: number = 10,
) => {
  return useSWR(
    !!lat && !!lon
      ? `${getSearchApi()}/parks?lat=${lat}&lon=${lon}&type=${type}&limit=${limit}`
      : null,
    (url: string) => apiRequest<INearbyPark[]>({ url }, true),
  );
};
